import NotificationButton from '@/components/common/NotificationButton';
import { useAppDispatch, useAppSelector } from '@/state/hooks';
import {
    openNotifications,
    selectNotificationsOpened,
    setNotificationsVisited
} from '@/state/reducers/notificationSlice';
import { UseDisclosureReturn } from '@/utils/hooks/useDisclosure';
import { MobileDrawerButton } from '../MobileNavbar';

interface PortalMobileNavbarProps {
    drawerDisclosure: UseDisclosureReturn;
}

const PortalMobileNavbar = ({ drawerDisclosure }: PortalMobileNavbarProps) => {
    const dispatch = useAppDispatch();
    const notificationsOpened = useAppSelector(selectNotificationsOpened);

    return (
        <div className="flex lg:hidden h-full gap-2 mr-1">
            <NotificationButton
                size="w-6 h-6"
                isActive={notificationsOpened}
                onClick={() => {
                    dispatch(openNotifications());
                    dispatch(setNotificationsVisited(true));
                }}
            />
            <MobileDrawerButton drawerDisclosure={drawerDisclosure} />
        </div>
    );
};

export default PortalMobileNavbar;
